export const FULLSTORY_MASK_CLASSNAME = 'fs-mask'
